import { getAliasedHeaders } from "./getAliasedHeaders";

export default getAliasedHeaders;
